import PageLoader from '@/app/common/components/PageLoader/PageLoader'
import { useTranslation } from 'react-i18next'
import { useGetExpenseCategories } from '../../api/usePaymentProviders'
import {
  SelectExpenseCategoriesForm,
  TExpenseForm,
} from './select_expense_categories-form'


type Props = {
  defaultValues: TExpenseForm
  onNext: (data: TExpenseForm) => void
  onBack: () => void
}

export function SelectExpenseTypePage(props: Props) {
  const { defaultValues, onBack, onNext } = props

  const { t } = useTranslation()


  const query = useGetExpenseCategories({
    pay_provider: 1,
  })

  const handleSubmit = (data: TExpenseForm) => {
    onNext(data)
  }

  const handleBack = () => {
    onBack()
  }

  return (
    <PageLoader query={query}>
      {(expenses) => (
        <SelectExpenseCategoriesForm
          defaultValues={defaultValues}
          invoiceLabel={t("invoice_number")}
          expenses={expenses}
          onSubmit={handleSubmit}
          onBack={handleBack}
        />
      )}
    </PageLoader>
  )
}
